import { CustomFont } from './CustomFont'

export const GeneralFont = () => {
  return (
    <CustomFont
      formikKey='font'
      labelKey='landings.create.wizard.landing.modal.custom.style.font.title'
    />
  )
}
